import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Phone, Star } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
export function Hero() {
  return <section className="relative min-h-screen flex items-center overflow-hidden bg-navy" data-id="element-73">
      {/* Parallax Background with Sparkles */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy to-navy/90" data-id="element-74">
        {/* Animated sparkle particles */}
        <div className="absolute inset-0 opacity-30" data-id="element-75">
          {[...Array(20)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-lime rounded-full" style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`
        }} animate={{
          scale: [0, 1, 0],
          opacity: [0, 1, 0]
        }} transition={{
          duration: 2 + Math.random() * 2,
          repeat: Infinity,
          delay: Math.random() * 2
        }} data-id="element-76" />)}
        </div>
        {/* Green glow effects */}
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-lime/10 rounded-full blur-3xl" data-id="element-77" />
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-electric-blue/10 rounded-full blur-3xl" data-id="element-78" />
      </div>

      <div className="container mx-auto px-4 py-24 md:py-32 relative z-10" data-id="element-79">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-80">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6 md:space-y-8" data-id="element-81">
            {/* Pill Tag */}
            <Badge className="bg-lime/20 text-lime border-lime/40 px-4 py-2 text-sm font-bold tracking-wider inline-flex items-center gap-2" data-id="element-82">
              <Zap className="w-4 h-4" data-id="element-83" />
              PHOENIX'S NERDIEST JUNK HAULERS
            </Badge>

            {/* Massive Headline */}
            <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-none tracking-tight" data-id="element-84">
              <span className="block text-white text-shadow-hero" data-id="element-85">
                JUNK GONE.
              </span>
              <span className="block text-white text-shadow-hero" data-id="element-86">
                GARAGE CLEAN.
              </span>
              <span className="block text-lime text-shadow-hero" data-id="element-87">
                DONE TODAY.
              </span>
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-white/90 max-w-xl leading-relaxed" data-id="element-88">
              Same-day junk removal and garage cleanouts across the Valley.
              Fast. Clean. Affordable. Text us a photo, get a quote in minutes.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-89">
              <Button size="lg" className="bg-lime text-navy hover:bg-lime/90 font-bold text-lg px-8 h-14 rounded-full shadow-[0_0_20px_rgba(163,230,53,0.5)] hover:shadow-[0_0_30px_rgba(163,230,53,0.7)] transition-all" data-id="element-90">
                GET FREE QUOTE
              </Button>
              <a href="tel:4252697387" className="inline-flex" data-id="element-91">
                <Button size="lg" variant="outline" className="border-2 border-lime text-lime hover:bg-lime/10 font-bold text-lg px-8 h-14 rounded-full w-full" data-id="element-92">
                  <Phone className="w-5 h-5 mr-2" data-id="element-93" />
                  CALL (425) 269-7387
                </Button>
              </a>
            </div>

            {/* Trust Row */}
            <div className="flex flex-wrap items-center gap-4 md:gap-6 pt-6 text-sm md:text-base" data-id="element-94">
              <div className="flex items-center gap-1" data-id="element-95">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-96" />)}
              </div>
              <span className="text-white/80 font-medium" data-id="element-97">5-Star Rated</span>
              <span className="text-lime" data-id="element-98">•</span>
              <span className="text-white/80 font-medium" data-id="element-99">
                Licensed & Insured
              </span>
              <span className="text-lime hidden sm:inline" data-id="element-100">•</span>
              <span className="text-white/80 font-medium hidden sm:inline" data-id="element-101">
                Same-Day Service
              </span>
              <span className="text-lime hidden md:inline" data-id="element-102">•</span>
              <span className="text-white/80 font-medium hidden md:inline" data-id="element-103">
                Upfront Pricing
              </span>
            </div>
          </motion.div>

          {/* Right Image - hidden on mobile */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-104">
            <div className="relative" data-id="element-105">
              {/* Green glow behind logo */}
              <div className="absolute inset-0 bg-lime/20 rounded-full blur-3xl scale-110" data-id="element-106" />
              <img src="https://cdn.magicpatterns.com/uploads/tAQ2hBAg2YykrLwSQc6Y3H/AZ-JunkNerds-logo-v2.png" alt="AZ Junk Nerds Character" className="relative w-full max-w-lg mx-auto drop-shadow-[0_0_30px_rgba(163,230,53,0.4)]" data-id="element-107" />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Diagonal divider at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-navy clip-diagonal" data-id="element-108" />
    </section>;
}